import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { ControlHelperTextProps } from "../types";

export default function ControlHelperText(
  props: Readonly<ControlHelperTextProps>,
) {
  const { size = "md", error, className, ...rest } = props;

  return (
    <div
      {...rest}
      className={twMerge(
        clsx("w-full transition-all", {
          "text-red-500 border border-red-100 rounded-md px-2 py-1 bg-red-50 mt-2":
            error,
          "text-slate-500 mt-1": !error,
          "text-xs": size === "sm",
          "text-sm": size === "md",
          "text-base": size === "lg",
        }),
        className,
      )}
    />
  );
}
